//元素权限判断
exports.install = function (Vue, options) {
  //eId=元素ID
  Vue.prototype.hasPM = function (eId){
    if(this.$store.state.userInfo == null){
      return false;
    }
    if(!this.$store.state.userInfo.elementsMap["e_"+eId]){
      return false;
    }
    return true;
  };
};



// WEBPACK FOOTER //
// ./src/assets/js/permission.js